import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getQSVar } from '../utils';
import { nl } from './nl';
import { fr } from './fr';

export const initI18n = () => {
    const lng = getQSVar('lng') || 'nl';

    i18n.use(initReactI18next).init({
        lng: lng,
        resources: {
            nl: {
                translation: nl,
            },
            fr: {
                translation: fr,
            },
        },
        fallbackLng: 'nl',
        debug: process.env.NODE_ENV === 'development',
    });
};
